import Header from '../components/Header';
import Hero from '../components/Hero';
import Products from '../components/Products';
import About from '../components/About';
import Roadmap from '../components/Roadmap';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import usePageMeta from '../hooks/usePageMeta';

const HomePage = () => {
  usePageMeta(
    'Northwest Title Alliance — AI Tools for Title Professionals',
    'Northwest Title Alliance builds AI-powered tools for title professionals — the AXIOM virtual underwriter family, ART, the AI-rendered title plant, and TrueNorth survey intelligence. Northwest roots, national reach.'
  );
  return (
    <div className="min-h-screen bg-[#F6F8FA]">
      <Header />
      <main>
        <Hero />
        <Products />
        <About />
        <Roadmap />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
